import type { ReactNode } from "react";
import { ConfigContext, type ConfigContextType } from "./use-context";

export default function ConfigProvider({
	children,
	bearerToken,
	pod,
}: ConfigContextType & { children: ReactNode }) {
	return (
		<ConfigContext.Provider value={{ bearerToken, pod }}>
			{children}
		</ConfigContext.Provider>
	);
}
